import React from 'react';
import { Stack, Typography, useTheme } from '@mui/material';
import {
  STACK_CENTER_COLUMN_DIRECTION,
  STACK_CENTER,
} from '../../constants/mui-components';
import {
  statisticsContainer,
  statisticsContent,
  statisticsTypography,
} from './styles/statistics.styles';
import { AnimatedNumber } from '../../components/animations';
import statistics from '../../constants/home/statistics';
import useGetCountry from '../../helpers/useGetCountry';

function Statistics() {
  const theme = useTheme();
  const country = useGetCountry();
  return (
    <Stack className={STACK_CENTER} sx={statisticsContainer}>
      <Stack className={STACK_CENTER} sx={statisticsContent(theme)}>
        {statistics[country]?.map((statistic) => (
          <Stack
            key={statistic.key}
            className={STACK_CENTER_COLUMN_DIRECTION}
            width={{ xs: '100%', desktop: '25rem' }}
            minWidth="10rem"
          >
            <Stack className={STACK_CENTER} minHeight="5rem">
              <AnimatedNumber
                targetValue={statistic.targetValue}
                from={statistic.from}
                duration={1500}
                prefix={statistic.prefix}
                suffix={statistic.suffix}
                moneySuffix={statistic.moneySuffix}
                variant="title_1"
                fontWeight={800}
              />
            </Stack>
            <Typography variant="medium_3" sx={statisticsTypography}>
              {statistic.description}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}

export default Statistics;
